/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo } from 'react';
import Table, {
  TableColumn,
} from '../../../../../components/common/table/table';
import { AnimalEventAnimal } from '../../../../../interfaces/animal-event';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import TableVerticalSizeFixer from '../../../../../components/common/table/table-vertical-size-fixer/table-vertical-size-fixer';

interface Props {
  animals: AnimalEventAnimal[];
  removeRow?: (index: number, data: AnimalEventAnimal[]) => void;
  eventType: string;
  showRemove: boolean;
}

function FormTable({ animals, removeRow, eventType, showRemove }: Props) {
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    setValue('animals', animals);
  }, [animals, getValues]);
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { [key: string]: string | number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  const columns: TableColumn<AnimalEventAnimal>[] = useMemo(() => {
    const data: TableColumn<AnimalEventAnimal>[] = [
      {
        accessor: 'animal_id',
        header: tp('events.grazing.id'),
        sortable: false,
        className: 'animal_id',
      },
      {
        accessor: 'name',
        header: tp('events.grazing.name'),
        sortable: false,
        className: 'name',
      },
      {
        accessor: 'breed_code',
        header: tp('events.breeding.breed'),
        sortable: false,
        className: 'breed_code',
      },
      {
        accessor: 'age',
        header: tp('events.breeding.age'),
        sortable: true,
        className: 'breed_code',
        valuable: (value) => {
          if (value === '0') {
            return value;
          } else {
            const dateValues = value.split(' ');
            const dateElement = ['g. ', 'mēn. ', ' d.'];
            let date = '';
            for (let index = 0; index < dateElement.length; index++) {
              if (dateValues[index] !== '0') {
                date += dateValues[index] + dateElement[index];
              }
            }
            return date;
          }
        },
      },
    ];

    return data;
  }, [eventType, tp]);

  return (
    <TableVerticalSizeFixer>
      <Table<AnimalEventAnimal>
        data={animals}
        keyAccessor="id"
        onRemove={removeRow}
        filteredTotalsParams={{
          recordName: 'pages.livestock.animals_and_events.events.table_title',
          fullText: { tp, key: 'events.table_title' },
        }}
        paginate={false}
        showRemove={showRemove}
        columns={columns}
      />
    </TableVerticalSizeFixer>
  );
}

export default FormTable;
